import { render, staticRenderFns } from "./ProductStockCard.vue?vue&type=template&id=0f9781a0&scoped=true"
import script from "./ProductStockCard.vue?vue&type=script&lang=js"
export * from "./ProductStockCard.vue?vue&type=script&lang=js"
import style0 from "./ProductStockCard.vue?vue&type=style&index=0&id=0f9781a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9781a0",
  null
  
)

export default component.exports